import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogContent } from '@bb-ui/react-library';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';

export const WaitingIfAuthorHasAssetsDialogContent = () => {
    const { t } = useTranslation();

    return (
        <>
            <DialogContent
                style={{
                    minHeight: '231px',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: 'calc(100% - 5px)',
                    }}
                >
                    <CircularProgress
                        aria-label={t(
                            'settings.licenseManagement.delete.assetValidationInProgress',
                        )}
                        size={50}
                        data-testid="asset-validation-in-progress"
                    />
                </div>
            </DialogContent>
        </>
    );
};
